import { useMutation } from "@tanstack/react-query";
import i18next from "i18next";
import { ApiGetSignal } from "@/api";
import {
  GetSignalResultCode,
  type GetSignalRequest,
  type GetSignalResponse,
} from "@/api/types";
import { showError, showSuccess } from "@/lib/toast";

/**
 * 获取 AI 交易信号（/game/cex/GetSignal）
 */
export function useGetSignal() {
  return useMutation({
    mutationFn: async (data: GetSignalRequest): Promise<GetSignalResponse> => {
      console.log("useGetSignal", data);
      const res = await ApiGetSignal(data);
      console.log("useGetSignal", res.data);
      return res.data;
    },
    onError: error => {
      console.error("useGetSignal error", error);
      showError(
        i18next.t("aiTradingPage.strategyWizard.toastGetSignalFailedRetry")
      );
    },
    onSuccess: data => {
      console.log("useGetSignal success", data);
      if (data.resultCode === GetSignalResultCode.Success) {
        return;
      }
      if (data.resultCode === GetSignalResultCode.OkxAvailCashRatio) {
        showError(
          i18next.t("aiTradingPage.strategyWizard.toastSignalVolatilityTooHigh")
        );
      }
      if (data.resultCode === GetSignalResultCode.ChannelClose) {
        showError(i18next.t("common.comingSoon"));
      }
      showError(
        data.resultMsg ||
          i18next.t("aiTradingPage.strategyWizard.toastGetSignalFailed")
      );
    },
  });
}
